import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToggleSwitchComponent } from './toggle-switch/toggle-switch.component';
import { CustomButtonComponent } from './custom-button/custom-button.component';
import { MatRippleModule } from '@angular/material/core';
import { RoundContainedIconComponent } from './round-contained-icon/round-contained-icon.component';
import { RoundedContainerForHtmlComponent } from './rounded-container-for-html/rounded-container-for-html.component';
import { AddFieldButtonComponent } from './add-field-button/add-field-button.component';
import { BackNextButtonsComponent } from './back-next-buttons/back-next-buttons.component';
import { DashedOutlinedThemeColorButtonComponent } from './dashed-outlined-theme-color-button/dashed-outlined-theme-color-button.component';
import { CustomCheckboxWithTitleAndSubtitleComponent } from './custom-checkbox-with-title-and-subtitle/custom-checkbox-with-title-and-subtitle.component';
import { CustomRadioButtonsWithTitleAndSubtitleComponent } from './custom-radio-buttons-with-title-and-subtitle/custom-radio-buttons-with-title-and-subtitle.component';

@NgModule({
  declarations: [
    ToggleSwitchComponent,
    CustomButtonComponent,
    RoundContainedIconComponent,
    RoundedContainerForHtmlComponent,
    AddFieldButtonComponent,
    BackNextButtonsComponent,
    DashedOutlinedThemeColorButtonComponent,
    CustomCheckboxWithTitleAndSubtitleComponent,
    CustomRadioButtonsWithTitleAndSubtitleComponent,
  ],
  imports: [CommonModule, MatRippleModule],
  exports: [
    ToggleSwitchComponent,
    CustomButtonComponent,
    RoundContainedIconComponent,
    RoundedContainerForHtmlComponent,
    AddFieldButtonComponent,
    BackNextButtonsComponent,
    DashedOutlinedThemeColorButtonComponent,
    CustomCheckboxWithTitleAndSubtitleComponent,
    CustomRadioButtonsWithTitleAndSubtitleComponent,
  ],
})
export class ButtonsModule {}
